module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-ee46ff83.svg";